import {
    request,
    requestPublic
} from './request.js'
// 获取普本专业院校列表
export function getMajorPtSchoolList(obj) {
    return request({
        url: '/api2/ZsbSiteAdmin/MajorPt/MajorPtSchoolList',
        method: 'get',
        params: {
            Year: obj.year,
            Name: obj.name,
            SchoolName: obj.schoolName,
            MajorCategoryId: obj.majorCategoryId,
            pageIndex: obj.pageIndex,
            pageSize: obj.pageSize,
        }
    })
}

//获取普本专业院校详情
export function findById(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/MajorPt/FindById',
        method: 'get',
       params:{
        id: id
       }
    })
}
// 新增普本专业院校
export function addSchoolMajor(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/MajorPt/Add',
        method: 'post',
        data: data
    })
}

// 修改普本专业院校
export function editSchoolMajor(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/MajorPt/Edit',
        method: 'post',
        data: data
    })
}

// 删除普本专业院校
export function delSchoolMajor(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/MajorPt/Delete',
        method: 'post',
        params:{
            id: id
           }
    })
}